// extracted by mini-css-extract-plugin
export default {"center":"styles-module__center__src-labstep-web-screens-Organization-FreeTrialEnded-_T3iKa"};